export const listVehiclesAndStateTypes = {
    VEHICLE_SELECT: 'LISTVEHICLES_AND_STATE_VEHICLE_SELECT',
    TOGGLE_STATE: 'LISTVEHICLES_AND_STATE_TOGGLE_STATE',

    CLEANUP: 'LISTVEHICLES_AND_STATE_CLEANUP',
};


